import React from 'react';
//import SolarTrackerScene from './SolarTrackerScene';
import SolarSimulation from './SolarSimulation';

function App() {
  return (
    <div>
      <SolarSimulation />
    </div>
  );
}

export default App;
